import { ColorType } from '../../assets/colors/colors.g';

export const userStyles = {
  container: {
    marginBottom: '1rem',
    marginTop: '1rem',
    padding: '12px',
  },
  wrapper: {
    display: 'flex',
  },
  item: {
    display: 'flex',
    alignItems: 'center',
  },
  verified: {
    color: ColorType.POSITIVE,
  },
  notVerified: {
    color: '#FF8F00',
  },
  title: {
    fontSize: 16,
    fontWeight: 600,
    lineHeight: '24px',
    fontFamily: 'Inter',
    fontStyle: 'normal',
    color: '#202223',
  },
  description: {
    fontSize: 14,
    fontWeight: 400,
    lineHeight: '20px',
    fontFamily: 'Inter',
    fontStyle: 'normal',
    color: '#6B7684',
  },
  heading: {
    fontFamily: 'Inter',
    fontStyle: 'normal',
    fontSize: 18,
    color: '#202223',
    lineHeight: '26px',
    fontWeight: 600,
    marginBottom: 12,
    marginTop: 12,
  },
  itemWrapper: {
    borderRadius: '12px',
    border: '1px solid #E5E8EB',
  },
  itemIcon: {
    alignSelf: 'baseline',
    marginTop: 6,
    minWidth: 32,
  },
  forwardIcon: {
    fontSize: 18,
    color: '#B0B8C1',
  },
  disableRipple: {
    '&:hover': {
      backgroundColor: 'transparent',
    },
  },
  formWrapper: {
    padding: '8px 20px',
    // maxWidth: 425,
  },
  formInput: {
    marginTop: 20,
    marginBottom: 10,
  },
  paddingTop: {
    paddingTop: 8,
  },
  dropDownMenu: {
    backgroundColor: '#fff',
    position: 'absolute' as 'absolute',
    display: 'block',
    listStyleType: 'none',
    left: 0,
    marginTop: 16,
    borderRadius: '4px',
    boxShadow: '0px 2px 10px rgba(0, 0, 0, 0.1)',
    maxHeight: '30rem',
    overflow: 'auto',
    zIndex: 1,
  },
  dropdownMenuItem: {
    minWidth: '110px',
    padding: 16,
    cursor: 'pointer',
    borderRadius: '4px',
    color: '#4e5968',
  },
  dropdownMenuItemHover: {
    '&:hover': {
      backgroundColor: '#F7F7F7',
    },
  },
  drodDownButton: {
    background: '#F2F4F6',
    width: '100%',
    height: '48px',
    borderRadius: '4px',
    padding: '12px 8px 12px 16px',
    cursor: 'pointer',
    border: 0,
    position: 'relative' as 'relative',
    display: 'inline-block',
  },
  dropDownSelectedItem: {
    backgroundColor: ColorType.GREY1,
    color: '#18A0D7',
    borderRadius: '0.25rem',
  },
  width110: {
    width: '110px',
  },
  inputWrapper: {
    '& .MuiFilledInput-input': {
      padding: '12px 16px',
      boxSizing: 'border-box' as 'border-box',
      backgroundColor: '#F2F4F6',
      borderRadius: '4px',
      fontFamily: 'Inter',
      outline: 0,
      height: '48px',
      border: '2px solid #F2F4F6',
    },
    '& .MuiFilledInput-root': {
      borderRadius: '4px',
      border: '2px solid #F2F4F6',
    },
    '&::placeholder': {
      color: '#B0B8C1',
    },
    '& .Mui-focused': {
      border: '2px solid #000000',
    },
  },
  paddingBottom8: {
    paddingBottom: '8px',
  },
  labelB2: {
    fontFamily: 'Inter',
    fontSize: 16,
    fontWeight: 400,
    lineHeight: '24px',
    fontStyle: 'normal',
    color: '#202223',
  },
  labelM: {
    fontFamily: 'Inter',
    fontSize: 16,
    fontWeight: 600,
    lineHeight: '24px',
    fontStyle: 'normal',
    color: '#202223',
  },
  labelS: {
    fontSize: 14,
    fontWeight: 500,
    lineHeight: '20px',
    fontFamily: 'Inter',
    fontStyle: 'normal',
  },
  displayBlock: {
    display: 'block',
  },
  textOverflow: {
    textOverflow: 'ellipsis',
    overflow: 'hidden',
  },
  marginY8: {
    marginTop: '8px',
    marginBottom: '8px',
  },
};
